import { Play, RefreshCcw, Workflow } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";
import { DataTable } from "../components/DataTable";
import { useWorkflowQueue } from "../data/supergestor-data";

export function WorkflowsPage() {
  const query = useWorkflowQueue();
  return (
    <div className="page-stack">
      <section className="metric-grid metric-grid-four">
        <article className="metric-card">
          <Workflow size={20} />
          <span>Instâncias</span>
          <strong>{query.data?.length ?? 0}</strong>
          <small>Fluxos ativos</small>
        </article>
        <article className="metric-card">
          <Play size={20} />
          <span>Ações pendentes</span>
          <strong>{query.data?.reduce((s, i) => s + i.pending, 0) ?? 0}</strong>
          <small>Worker</small>
        </article>
        <article className="metric-card">
          <RefreshCcw size={20} />
          <span>Falhas</span>
          <strong>{query.data?.reduce((s, i) => s + i.failed, 0) ?? 0}</strong>
          <small>Revisão manual</small>
        </article>
        <article className="metric-card">
          <span>Definições</span>
          <strong>5</strong>
          <small>Planos, vendas e locações</small>
        </article>
      </section>
      <Card
        title="Central de workflows"
        description="Transições declarativas, requisitos e ações idempotentes."
        action={
          <Button>
            <Play size={16} /> Nova instância
          </Button>
        }
      >
        <DataTable
          rows={query.data ?? []}
          getKey={(row) => row.id}
          columns={[
            { key: "workflow", header: "Workflow", render: (row) => row.workflow },
            { key: "entity", header: "Entidade", render: (row) => row.entityType },
            {
              key: "state",
              header: "Estado",
              render: (row) => <Badge tone="info">{row.state}</Badge>,
            },
            { key: "pending", header: "Pendentes", render: (row) => row.pending },
            {
              key: "failed",
              header: "Falhas",
              render: (row) => <Badge tone={row.failed ? "danger" : "success"}>{row.failed}</Badge>,
            },
            { key: "updated", header: "Atualização", render: (row) => row.updatedAt },
          ]}
        />
      </Card>
    </div>
  );
}
